const actions = {
  FETCH_DRAFT: 'publishing/FETCH_DRAFT',
  FETCH_APPROVAL_NEEDED: 'publishing/FETCH_APPROVAL_NEEDED',
  FETCH_HISTORY: 'publishing/FETCH_HISTORY',
}

export default actions
